<template>
  <div class="h-pm-dataQuery-tree">
      <ejs-treeview ref='measureTreeForNoRealQuery' :fields='fields' :nodeSelected='nodeSelectedOfMeasureTreeForNoRealQuery'></ejs-treeview>
  </div>
</template>

<script>
export default {
  name: 'MeasureTreeForNoRealQuery',
  data() {
    return {
      fields: {
        dataSource: [{ children: [] }],
        id: 'id',
        text: 'text',
        child: 'children',
        expanded: 'state',
        tooltip: 'text'
      },
    };
  },
  methods: {
    // 测量对象树内容获取
    getMeasureObjectTreeForQuery(measureobjectname) {
      this.$axios.post(`/lte/pm/getDefaultTemplateTree.html?systemId=1&measureobjectname=${measureobjectname || ''}`).then((response) => {
        this.fields = {
          dataSource: response.data,
          id: 'id',
          text: 'text',
          child: 'children',
          expanded: 'state'
        };
      });
    },

    // 测量对象树点击事件
    nodeSelectedOfMeasureTreeForNoRealQuery(node) {
      this.$emit('transferMeasureObjForQuery', node);
    }
  },
  mounted() {
    this.getMeasureObjectTreeForQuery();
  }
};
</script>

<style>

</style>
